import * as Sentry from '@sentry/react';

const dsn = import.meta.env.VITE_SENTRY_DSN;

if (!dsn) {
  console.warn('Missing VITE_SENTRY_DSN — Sentry error reporting disabled.');
} else {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    beforeSend(event) {
      // Strip query params from fetch breadcrumb URLs (Supabase tokens)
      if (event.breadcrumbs) {
        for (const crumb of event.breadcrumbs) {
          if (crumb.category === 'fetch' && crumb.data?.url) {
            try {
              const url = new URL(crumb.data.url);
              url.search = '';
              crumb.data.url = url.toString();
            } catch {
              // leave URL as-is if unparseable
            }
          }
        }
      }
      return event;
    },
  });
}

export { Sentry };
